import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITEM_ATA.TRANSFERENCIA.HISTORICO.BUSCAR_HISTORICO_TRANSFERENCIA]({ state }, idAtaItem) {
		const { data } = await api.transferencia.buscarHistoricoTransferencia(idAtaItem, state.paginacao)

		return data
	},
}
